export default __webpack_public_path__ + "static/media/second-place.192ba2ea.svg";